module.exports = __webpack_public_path__ + "static/media/12_pol_0_89.54.443933b0.png";